import { Map, Set, List } from 'immutable';

type BehaviorState = Map<string, any>;

export const pendingGreetings = (state: BehaviorState): List<any> => {
    return state.get('pendingGreetings', List());
};

export const greetingsDelayMs = (state: BehaviorState): number => {
    return state.get('greetingsDelayMs');
};

export const largeChatSize = (state: BehaviorState): boolean => {
    return state.get('largeChatSize', false);
};
